















import { Vue, Component, Prop } from 'vue-property-decorator';
import { ICustomStylingClass } from './types/custom.t';

@Component
export default class CustomSvgIcon extends Vue {

  @Prop({required: true })
  src!: string;

  @Prop()
  width?: string;

  @Prop()
  height?: string;

  @Prop()
  customStyle?: ICustomStylingClass[];

  @Prop()
  role?: string;

  @Prop()
  alt?: string;

  @Prop()
  title?: string;

  @Prop()
  customClass?: ICustomStylingClass[];

  svgContent: string = '';

  public get iconUrl(): string {
    return this.$store.state.endPoints.customizer.customsAssets;
  }

  created() {
    fetch(this.src)
      .then((response) => {
        if (response.status !== 200) {
          throw response;
        }
        return response.text();
      })
      .then((content) => {
        this.svgContent = content;
      })
      .catch((ex) => {
        console.error("Could not load the svg file from the url.", ex);
      });
  }

}
